var exports = {
  "x": "gridColumnTemplate__kXqy-c",
};

module.exports = exports;
